import React, {  useState, useMemo } from 'react'
import "./ContactPageForm.css"
import axios from 'axios'
import { Spinner } from 'react-bootstrap'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import Select from "react-select";
import countryList from "react-select-country-list";


function ContactPageForm() {

    const [name,setName]= useState("")
    const [email,setEmail]= useState("") 
    const [city,setCity]= useState("") 
    const [town,setTown]= useState("") 
    const [zip,setZip]= useState("")
    const [phone, setPhone] = useState("");
   
    const [message,setMessage]= useState("")

    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);


    const formSubmitHandler = (e) => {
        e.preventDefault();
        setLoading(true);

        setTimeout(()=>{
            setLoading(false)
        },3000)
        axios
          .post("/send-contact-form-main", {
            formType: "Contact Page Form",
            name:name,
            email:email,
            city:city,
            zip:zip,
            phone:phone,
            message:message,
          })
          .then((response) => {
            if (response.data.msg === "success") {
              setError(false);
              setSuccess("Appointment form Submited Successfully!");
              setLoading(false);
              setEmail("");
              window.open("/thank-you", '_blank');
            } else if (response.data.msg === "fail") {
              setSuccess(false);
              setError("Failed to send form, try again by reloading the page.");
              setLoading(false);
              setEmail("");
            }
          });
      };

      const handlePhoneChange = (e) => {
        // Allow only numeric values and limit the length
        const numericValue = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
        const maxLength = 20; // Adjust as needed
    
        // Update state only if the value is within the specified range
        if (numericValue.length <= maxLength) {
          setPhone(numericValue);
        }
      };
  return (
    <div className='ContactPageForm-container standard-padding-space '>
        <div className='container pt-5'>
            <div className='row align-items-center gy-lg-0 gy-5'>
            <div className='col-lg-6'>
                    <div className='content-container text-lg-start text-center'>
                       <h3 className='body-heading mb-3'>Contact Information</h3>
                        
                        <div className='row'>
                            {/* <div className='col-lg-6 p-2 h-100'>
                                <div className='form-info-container d-flex flex-lg-row flex-column align-items-center gap-2 justify-content-evenly px-2 py-3'>

                                    <img src='/images/icons/contact-page-info-location.png' style={{background:"#D73344"}} alt='location icon'/>
                                    <div>
                                        <h4 className='mb-1' style={{color:"black",fontWeight:"bold"}}>Our Address</h4>
                                        <p className='mb-0'>6391 Elgin St. Celina,<br></br> Delaware 10299</p>
                                    </div>
                                </div>
                            </div> */}
                            <div className='col-lg-8 p-2 h-100'>
                                <div className='form-info-container d-flex flex-lg-row flex-column align-items-center gap-2 justify-content-start gap-4 px-3 py-3 '>

                                    <img src='/images/icons/contact-page-info-phone.png' style={{background:"#5ca4a7"}} alt='location icon'/>
                                    <div>
                                        <h4 className='mb-1' style={{color:"black",fontWeight:"bold"}}>Phone Number</h4>
                                        <a className='mb-0 ' href='tel:647-367-0067' style={{color:"black",textDecoration:"none"}}>647-367-0067</a>
                                        <br></br>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-8 p-2 h-100'>
                                <div className='form-info-container d-flex flex-lg-row flex-column align-items-center gap-4 justify-content-start px-3 py-3'>

                                    <img src='/images/icons/contact-page-info-mail.png' style={{background:"#5ca4a7"}} alt='location icon'/>
                                    <div>
                                        <h4 className='mb-1' style={{color:"black",fontWeight:"bold"}}>Email Address</h4>
                                        <a className='mb-0 ' href='mailto:info@mobilelasertherapy.ca' style={{color:"grey",textDecoration:"none"}}>info@mobilelasertherapy.ca</a>
                                        <br></br>
                                        
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-8 p-2 h-100'>
                                <div className='form-info-container d-flex flex-lg-row flex-column align-items-center gap-4 justify-content-start px-3 py-3'>

                                    <img src='/images/icons/contact-page-info-time.png' style={{background:"#5ca4a7"}} alt='location icon'/>
                                    <div>
                                        <h4 className='mb-1' style={{color:"black",fontWeight:"bold"}}>Hours of Operation</h4>
                                        <p className='mb-0'>Mon - Fri: 9AM - 7PM</p>
                                        <p className='mb-0'>Sat: 11AM - 4PM</p>
                                        <p className='mb-0'>Sun: Closed</p>
                                    </div>
                                </div>
                            </div>
                            
                            
                        </div>

                       
                        <h3 className='mb-3 title-txt pt-4'>Follow The Social Media:</h3>
                        
                        <div className='d-flex align-items-center justify-content-lg-start justify-content-center gap-3 social-icons'>
                            <img src='/images/icons/footer-fb-icon.png' alt='facebook' style={{backgroundColor:"#57B1B8",borderRadius:"50%"}}/>
                            <img src='/images/icons/footer-insta-icon.png' alt='instagram' style={{backgroundColor:"#57B1B8",borderRadius:"50%",}}/>
                            {/* <img src='/images/icons/contact-x-icon.png' alt='x'/> */}
                        </div>
                    </div>

                </div>

                <div className='col-lg-6'>
                    <div className='form-container'>
                    {/* <h4 style={{fontWeight:"600",color:"black"}} className='text-center mb-3'>Book An Appointment</h4> */}
                    <h5 style={{fontWeight:"600",color:"black",textTransform:"uppercase"}} className='text-lg-start text-center mb-3' >Enter your details below to get started!</h5>

                        <form className='form-field d-flex flex-column justify-content-between col-lg-12' onSubmit={formSubmitHandler}>
                          
                                <input
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    maxLength="100"
                                    required
                                    type='text' 
                                    placeholder='Your Name' 
                                />

                            
                                <input
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    maxLength="100"
                                    required
                                    type='email' 
                                    placeholder='Your Email'
                                />
                                <input
                                    type="tel"
                                    value={phone}
                                    maxLength="22"
                                    required
                                    onChange={handlePhoneChange}
                                    placeholder='Your Phone'
                                />
                               

                          
                                <input
                                    value={city}
                                    onChange={(e) => setCity(e.target.value)}
                                    maxLength="100"
                                    type='text' 
                                    required
                                    placeholder='City/Town' 
                                />
                                {/* <input
                                    value={city}
                                    onChange={(e) => setCity(e.target.value)}
                                    maxLength="100"
                                    type='text' 
                                    required
                                    placeholder='City' 
                                /> */}
                                <input
                                    value={zip}
                                    onChange={(e) => setZip(e.target.value)}
                                    maxLength="100"
                                    type='text' 
                                    required
                                    placeholder='Postal Code' 
                                />

                                <textarea 
                                    placeholder='Write Message....'
                                    rows={3}
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    required
                                    
                                >

                                </textarea>
                               
                               
                            <button className='genral-btn mt-4' style={{backgroundColor:"black",color:"white",fontSize:"17px"}} type='submit' disabled={loading}>Submit

                            {loading ? (
                                        <Spinner
                                        animation="border"
                                        role="status"
                                        style={{ color: "white", width: "15px", height: "15px", marginLeft: "10px" }}
                                        />
                                    ) : (
                                        success ? (
                                        <div >
                                            {setLoading(false)}
                                            {/* {alert(success)} */}
                                            {setSuccess(false)}
                                        </div>
                                        ) : (
                                        error && (
                                            <div>
                                            {setLoading(false)}
                                            {alert(error)}
                                            {setError(false)}
                                            </div>
                                        )
                                        )
                                    )}
                            </button>
                        </form>
                    </div>
                </div>

               
            </div>
        </div>
    </div>
  )
}

export default ContactPageForm